import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import {
    AGENT_TASKS_DEF,
    GitBookAgentClientStatus,
    useAgentState,
    useChangeRequestAgent,
} from '../../../Components';

/**
 * Button to open the Agent side-panel.
 */
export function ChangeRequestAgentButton(
    props: {
        space: api.Space;
        changeRequest: api.ChangeRequest;
        screen: NavigationScreenSpaceState;
    } & Omit<ButtonProps, 'onPress' | 'label'>
) {
    const { space, changeRequest, screen, style, ...rest } = props;

    const agent = useChangeRequestAgent({
        organizationId: space.organization,
        spaceId: space.id,
        changeRequestId: changeRequest.id,
    });
    const agentState = useAgentState(agent);

    const task = agentState.messages[agentState.messages.length - 1]?.task;

    return (
        <Button
            kind="blank"
            size="medium"
            {...rest}
            href={{
                screen: {
                    sideSheet:
                        screen.sideSheet?.type === 'agent'
                            ? undefined
                            : {
                                  type: 'agent',
                              },
                },
            }}
            leadingIcon={
                <Icon.AIAgentAnimated
                    state={
                        agentState.status === GitBookAgentClientStatus.PROCESSING
                            ? 'loading'
                            : 'default'
                    }
                />
            }
            iconOnly
            style={style}
            active={screen.sideSheet?.type === 'agent'}
            label={
                task && agentState.status === GitBookAgentClientStatus.PROCESSING
                    ? AGENT_TASKS_DEF[task.type].label
                    : 'Brainstorm, plan, and implement changes with the GitBook Agent'
            }
        />
    );
}
